module.exports = __webpack_public_path__ + "img/startercp2023.fcae676a.jpg";